import { localStorageUtility } from '../clientUtils';

const transformObjectToString = (data) => {
  if (!data || data.length === 0) return undefined;
  const d = data.map((item) => item.id);
  return d.toString();
};

const logout = () => {
  localStorageUtility.onLogout();
  window.location.href = window.location.origin;
};

function handleError(err) {
  if (err?.response?.status === 401) {
    // logout();
    throw new Error({ message: 'user is not authorized' });
    // return;
  }
  throw err;
}

const getAccessToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      localStorageUtility.removeItem('showAgreement');
      logout();
      throw new Error('unauthorized');
    }
    return {
      Authorization: `Bearer ${token}`
      // 'ngrok-skip-browser-warning': '69420'
    };
  } catch (error) {
    throw new Error('unauthorized');
  }
};

const addOptionsToParams = (options) => {
  const obj = {};
  if (options) {
    Object.entries(options).forEach((entry) => {
      const [key, value] = entry;
      obj[key] = value;
    });
  }
  return obj;
};

export { handleError, getAccessToken, transformObjectToString, addOptionsToParams, logout };
